import { useCallback, useState } from 'react'

import {
  ConversationBootstrapModes,
  type ConversationBootstrap,
} from '../../hooks/useConversationStream'

export const useGlobalCommandView = () => {
  const [bootstrap, setBootstrap] =
    useState<Nullable<ConversationBootstrap>>(null)
  const [isGuidedIntakePromoOpen, setIsGuidedIntakePromoOpen] = useState(false)

  const startConversation = useCallback((query: string) => {
    setBootstrap({
      mode: ConversationBootstrapModes.NEW,
      initialQuery: query,
    })
  }, [])

  const resumeConversation = useCallback((conversationId: string) => {
    setBootstrap({
      mode: ConversationBootstrapModes.RESUME,
      conversationId,
    })
  }, [])

  const endConversation = useCallback(() => {
    setBootstrap(null)
  }, [])

  const openGuidedIntakePromo = useCallback(() => {
    setIsGuidedIntakePromoOpen(true)
  }, [])

  const closeGuidedIntakePromo = useCallback(() => {
    setIsGuidedIntakePromoOpen(false)
  }, [])

  return {
    data: { bootstrap },
    states: { isGuidedIntakePromoOpen },
    methods: {
      startConversation,
      resumeConversation,
      endConversation,
      openGuidedIntakePromo,
      closeGuidedIntakePromo,
    },
  }
}
